var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card main_price_block" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("p", [_vm._v("Поиск цены на сайте Mediately")]),
          _vm._v(" "),
          _c("SearchPrice"),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }